import React, { useMemo } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import AddTaskOutlinedIcon from '@mui/icons-material/AddTaskOutlined'
import CreateTask from 'features/taskManagement/CreateTask'

const FollowUpTaskModal = ({ task, onClose, onCreated }) => {
  const overrides = useMemo(() => ({
    title: `Follow-up: ${task?.title || ''}`,
    bpId: task?.building?.id || task?.buildingPassportId || '',
    followUpFor: task?.id || '',
    followUpTitle: task?.title || '',
  }), [task])

  return createPortal(
    <Backdrop onClick={onClose}>
      <Card onClick={e => e.stopPropagation()}>
        <Head>
          <HeadIcon><AddTaskOutlinedIcon style={{ fontSize: 20 }} /></HeadIcon>
          <HeadText>
            <Title>Create a follow-up task</Title>
            <Sub>The full task form, linked to “{task?.title}”. Lower down you can tick whether this task depends on the follow-up being done.</Sub>
          </HeadText>
          <CloseBtn onClick={onClose} aria-label='Close'><CloseRoundedIcon style={{ fontSize: 18 }} /></CloseBtn>
        </Head>
        <Body>
          <CreateTask
            embedded
            initialOverrides={overrides}
            onCreated={() => { onCreated?.(); onClose() }}
            onCancel={onClose}
          />
        </Body>
      </Card>
    </Backdrop>,
    document.body
  )
}

export default FollowUpTaskModal

const Backdrop = styled.div`
  position: fixed; inset: 0; z-index: 100020;
  background: rgba(14, 20, 38, 0.42);
  display: flex; align-items: center; justify-content: center; padding: 24px;
  @media (max-width: 640px) { align-items: flex-end; padding: 0; }
`
const Card = styled.div`
  background: #fff; border: 1px solid #eceef2; border-radius: 20px;
  width: min(760px, 100%); max-height: calc(100vh - 48px);
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 16px 44px rgba(12, 18, 41, 0.16);
  @media (max-width: 640px) { border-radius: 20px 20px 0 0; max-height: 95vh; }
`
const Head = styled.header`
  display: flex; align-items: flex-start; gap: 12px;
  padding: 18px 20px; border-bottom: 1px solid #f1f2f5; flex: none;
`
const HeadIcon = styled.div`
  flex: none; width: 38px; height: 38px; border-radius: 11px;
  background: #e9f6f7; color: #1f8b98;
  display: flex; align-items: center; justify-content: center;
`
const HeadText = styled.div`flex: 1; min-width: 0;`
const Title = styled.h2`margin: 0; font-size: 16px; font-weight: 800; color: #14171f;`
const Sub = styled.p`margin: 3px 0 0; font-size: 12.5px; line-height: 1.5; color: #6a7280;`
const CloseBtn = styled.button`
  flex: none; border: none; background: #f3f4f7; color: #6a7280;
  width: 30px; height: 30px; border-radius: 9px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  &:hover { background: #e9ebf0; }
`
const Body = styled.div`
  overflow-y: auto;
  padding: 16px 20px 20px;
`
